<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @close="closeDialog"
        width="1000px"
        title="新增版本发布"
    >
        <el-form
            ref="addForm"
            :rules="rules"
            :model="addForm"
            label-width="100px"
        >
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="发布标题" prop="title" size="small">
                        <el-input
                            clearable
                            placeholder="请输入发布标题"
                            maxlength="50"
                            size="small"
                            v-model="addForm.title"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                
                <el-col :span="12">
                    <el-form-item
                        label="项目名称"
                        size="small"
                        prop="project_id"
                    >
                        <el-select
                            v-model="addForm.project_id"
                            placeholder="请选择项目名称"
                            clearable
                            filterable
                            @change="selectProj"
                        >
                            <el-option
                                v-for="item in systemList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="发布日期"
                        size="small"
                        prop="publish_time"
                    >
                        <el-date-picker
                            v-model="addForm.publish_time"
                            type="date"
                            placeholder="发布日期"
                            size="small"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                
                <el-col :span="12">
                    <el-form-item label="版本号" prop="version" size="small">
                        <el-input
                            clearable
                            placeholder="请输入版本号"
                            maxlength="50"
                            size="small"
                            v-model="addForm.version"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="发布内容" size="small" prop="content">
                        <el-input
                            type="textarea"
                            placeholder="请输入发布内容"
                            maxlength="1000"
                            size="small"
                            v-model="addForm.content"
                            :autosize="{ minRows: 6, maxRows: 8 }"
                            resize="none"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="closeDialog">关闭</el-button>
        </span>
    </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
export default {
    data() {
        return {
            addForm: {
                title: "",
                version: "",
                project_id: "",
                publish_time: "",
                content: "",
            },
            rules: {
                title: [{ required: true, message: "请输入发布标题" }],
                version: [{ required: true, message: "请输入版本号" }],
                publish_time: [{ required: true, message: "请选择发布日期" }],
                project_id: [{ required: true, message: "请选择项目名称" }],
                content: [{ required: true, message: "请输入发布内容" }]
            },
            /* systemList: [
                {
                    label: "OA",
                    value: "OA"
                },
                {
                    label: "WMS",
                    value: "WMS"
                },
                {
                    label: "ERP",
                    value: "ERP",
                },
                {
                    label: "magento",
                    value: "magento",
                },
            ] */
        };
    },
    methods: {
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            // this.addForm = {
            //     carrier: "",
            //     carrier_en: "",
            //     carrier_code: "",
            //     site_url: "",
            //     // type_code: "OA",
            //     project_id: ""
            // };
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },
        selectProj(){
            oaApi.lastversions({project_id: this.addForm.project_id}, "get").then(res => {
                if (res) {
                    if (res.code == 200) {
                        this.addForm.version = res.data.version
                    }
                }
            });
        },
        /**
         *  保存
         */
        save() {
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    oaApi.versions({ ...this.addForm }, "post").then(res => {
                        if (res) {
                            if (res.code == 200) {
                                this.$message.success("新增成功");
                                this.$parent.versions();
                            }
                            this.closeDialog();
                        }
                    });
                }
            });
        },
        formatDate(date) {
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + m + "-" + d;
        },
    },
    props: {
        addVisible: Boolean,
        systemList: Array
    },
    watch: {
        addVisible:{
            handler(val){
                this.addForm.publish_time = this.formatDate(new Date());
                this.$parent.projectSelect();
            },
            // immediate: true
        }
    }
};
</script>
<style lang="scss">
.add {
    .el-form-item__content {
        .el-select,
        .el-select--small,
        .el-input--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }
}
</style>
